import { StatusLevel } from '@/types';
import { cn } from '../../lib/cn';
import { STATUS_DOT_CLASS, STATUS_HALO_CLASS } from './statusStyles';

export interface StatusDotProps {
  status: StatusLevel;
  size?: number;
  /** Soft halo ring behind the dot, matching the original mockup's status-dot rings. */
  halo?: boolean;
  className?: string;
}

/** The smallest status primitive — a colored dot, nothing else. Every pill/beacon composes this. */
export function StatusDot({ status, size = 8, halo = false, className }: StatusDotProps) {
  return (
    <span
      className={cn('inline-block shrink-0 rounded-full', STATUS_DOT_CLASS[status], halo && STATUS_HALO_CLASS[status], className)}
      style={{ width: size, height: size }}
    />
  );
}
